webpackJsonp([35783957827783],{

/***/ 106:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction) {
	    throw new Error(prefix);
	  } else {
	    throw new Error(prefix + ": " + (message || ''));
	  }
	}
	
	module.exports = invariant;


/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/valentin-radulescu-resume.4019ef34.pdf";

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/valentin-radulescu.6ee9896d.jpg";

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.indexQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(163);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _valentinRadulescu = __webpack_require__(134);
	
	var _valentinRadulescu2 = _interopRequireDefault(_valentinRadulescu);
	
	var _valentinRadulescuResume = __webpack_require__(105);
	
	var _valentinRadulescuResume2 = _interopRequireDefault(_valentinRadulescuResume);
	
	__webpack_require__(342);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.renderPosts = function renderPosts() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Posts'
	      ),
	      this.props.data.allMarkdownRemark.edges.map(function (_ref) {
	        var node = _ref.node;
	        return _react2.default.createElement(
	          'div',
	          { key: node.frontmatter.title },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: node.fields.slug },
	              node.frontmatter.title
	            ),
	            ' -',
	            ' ',
	            node.frontmatter.date
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            node.excerpt
	          )
	        );
	      })
	    );
	  };
	
	  IndexPage.prototype.render = function render() {
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        author = _props$data$site$site.author,
	        description = _props$data$site$site.description;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'index' },
	      _react2.default.createElement(
	        'div',
	        { className: 'intro-left' },
	        _react2.default.createElement(
	          'div',
	          { className: 'intro-left-inner' },
	          _react2.default.createElement('img', { src: _valentinRadulescu2.default, alt: author, width: '200', height: '200' }),
	          _react2.default.createElement(
	            'h1',
	            null,
	            description
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            '\uD83D\uDC49',
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:hi@valentin.io' },
	              'Get in touch'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'intro-right' },
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'intro-link-youtube',
	            href: 'https://www.youtube.com/c/ValentinRad'
	          },
	          _react2.default.createElement('i', { className: 'fa fa-youtube-play' }),
	          ' YouTube'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'intro-link-github',
	            href: 'https://github.com/RadValentin'
	          },
	          _react2.default.createElement('i', { className: 'fa fa-github' }),
	          ' Github'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'intro-link-linkedin',
	            href: 'https://www.linkedin.com/in/valentinrad/'
	          },
	          _react2.default.createElement('i', { className: 'fa fa-linkedin' }),
	          ' LinkedIn'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'intro-link-codepen', href: 'https://codepen.io/valentin/' },
	          _react2.default.createElement('i', { className: 'fa fa-codepen' }),
	          ' Codepen'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'intro-link-resume', href: _valentinRadulescuResume2.default },
	          _react2.default.createElement('i', { className: 'fa fa-file-pdf-o' }),
	          ' R\xE9sum\xE9'
	        )
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = IndexPage;
	var indexQuery = exports.indexQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 342:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-d5cd7f6913c27a662413.js